<script>
  import { onMount, afterUpdate } from "svelte";
  import { fade } from "svelte/transition";

  import { currentProgress } from "../stores/scrollVars.js";
  import mq from "../stores/mq.js"; // here, defined laptop = 992px

  export let colour;
  // export let sceneDetailProgress;


  // let pathLength;

  // const getPathLength = () => {
  //   let path = document.querySelector(".circleborder");
  //   if (path && path.getTotalLength() > 0) {
  //     return path.getTotalLength()
  //   }
  //   else return 0
  // };

  export let active;

  // $: console.log(Math.max(0, (1 - sceneDetailProgress)) * pathLength)

  // onMount(async () => {
  //   pathLength = getPathLength();
  // });

  // afterUpdate(async () => {
  //   pathLength = getPathLength();
  // });
</script>

  {#if active}
    <div
      class="circle-detail"
      style="
          left: -1%; 
          top: -1%;
          width: 102%;"
      out:fade="{{duration: 1000}}" 
    >
    <!-- ^match outro duration fade-out -->
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle class="circleborder {colour}" cx=50 cy=50 r=49 stroke-width="0.5%"    />
        <!-- <circle class="circleborder" cx={r * 1.05} cy={r * 1.05} {r} stroke-width={linewidth} 
        stroke-dashoffset={sceneDetailProgress < 0.1 ? 0 : (sceneDetailProgress - 0.1)/0.9 * pathLength} 
        /> -->
      </svg>
    </div>
  {/if}

<style>
  .circle-detail {
    position: absolute;
    z-index: var(--z-top);
    border-radius: 15px;
  }

  .circleborder {
    stroke: var(--voila-border);
    fill: none;
    /* stroke-dasharray: var(--pathlength) var(--pathlength); */
    filter: url(#fTexture2);
    /* transition: stroke 0.5s ease-in-out; */
    /* transition should match --detail-anim-in */
  }

  .negative {
    stroke: var(--voila-negative-annotation);
  }

  .positive {
    stroke: var(--voila-border);
    /* stroke: var(--voila-positive-annotation); */
  }


</style>
